/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!***************************************!*\
  !*** ./src/assets/js/blog-listing.js ***!
  \***************************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var BlogListing = /*#__PURE__*/function (_HTMLElement) {
  _inherits(BlogListing, _HTMLElement);

  var _super = _createSuper(BlogListing);

  function BlogListing() {
    var _this;

    _classCallCheck(this, BlogListing);

    _this = _super.call(this);
    _this.blogListingTemplateUrl = "blog-listing-fetch";
    _this.desktopOffset = _this.dataset.desktopOffset;
    _this.desktopFetchLimit = _this.dataset.desktopFetchLimit;
    _this.mobileOffset = _this.dataset.mobileOffset;
    _this.mobileFetchLimit = _this.dataset.mobileFetchLimit;
    _this.allArticles = _this.dataset.allArticles;
    _this.loadMoreDesktopButtons = _this.querySelectorAll('button[data-load-more-button]');
    _this.desktopGrid = _this.querySelector('.desktop-grid');
    _this.mobileGrid = _this.querySelector('.mobile-grid');
    _this.desktopFooterQuantity = _this.querySelector('.desktop-footer .pagination-label span');
    _this.mobileFooterQuantity = _this.querySelector('.mobile-footer .pagination-label span');
    return _this;
  }

  _createClass(BlogListing, [{
    key: "hideLoadMoreButton",
    value: function hideLoadMoreButton() {
      if (window.innerWidth < 1024) {
        this.querySelector('.mobile-footer button').classList.add('!hidden');
      } else {
        this.querySelector('.desktop-footer button').classList.add('!hidden');
      }
    }
  }, {
    key: "updateArticleQuantity",
    value: function updateArticleQuantity() {
      if (window.innerWidth < 1024) {
        this.mobileFooterQuantity.innerHTML = this.mobileGrid.querySelectorAll('.article-card').length;
        this.mobileOffset = this.mobileGrid.querySelectorAll('.article-card').length;

        if (this.mobileOffset == this.allArticles) {
          this.hideLoadMoreButton();
        }
      } else {
        this.desktopFooterQuantity.innerHTML = this.desktopGrid.querySelectorAll('.article-card').length;
        this.desktopOffset = this.desktopGrid.querySelectorAll('.article-card').length;

        if (this.desktopOffset == this.allArticles) {
          this.hideLoadMoreButton();
        }
      }
    }
  }, {
    key: "insertCards",
    value: function insertCards(cardsWrapper) {
      if (window.innerWidth < 1024) {
        this.mobileGrid.insertAdjacentHTML('beforeend', cardsWrapper.innerHTML);
      } else {
        this.desktopGrid.insertAdjacentHTML('beforeend', cardsWrapper.innerHTML);
      }
    }
  }, {
    key: "getPosts",
    value: function getPosts() {
      var _this2 = this;

      var currentOffset = this.desktopOffset;
      var currentLimit = this.desktopFetchLimit;

      if (window.innerWidth < 1024) {
        currentOffset = this.mobileOffset;
        currentLimit = this.mobileFetchLimit;
      }

      console.log("".concat(window.location.origin).concat(window.location.pathname, "?view=").concat(this.blogListingTemplateUrl, "&page=").concat(currentOffset / 3), 'fetch url');
      fetch("".concat(window.location.origin).concat(window.location.pathname, "?view=").concat(this.blogListingTemplateUrl, "&page=").concat(currentOffset / 3 + 1)).then(function (response) {
        return response.text();
      }).then(function (data) {
        var dataDom = new DOMParser().parseFromString(data, 'text/html');
        var cardsWrapper = dataDom.querySelector('.articles-wrapper');

        _this2.insertCards(cardsWrapper);

        _this2.updateArticleQuantity();
      });
    }
  }, {
    key: "initListeners",
    value: function initListeners() {
      var _this3 = this;

      if (this.loadMoreDesktopButtons.length) {
        this.loadMoreDesktopButtons.forEach(function (button) {
          button.addEventListener('click', function (e) {
            e.preventDefault();

            _this3.getPosts();
          });
        });
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initListeners();
    }
  }]);

  return BlogListing;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (customElements.get('blog-listing') === undefined) {
  customElements.define("blog-listing", BlogListing);
}
/******/ })()
;